<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" class="icon"
  ><g fill="#231F20" fill-rule="evenodd" class="icon__path"
    ><path d="M8.875 10.25v5.499h4.126L13 18.5l5.501-5.501-5.5-5.5-.001 2.75z" /><path
      d="M21.25 13c0 4.55-3.7 8.25-8.25 8.25S4.75 17.55 4.75 13 8.45 4.75 13 4.75s8.25 3.7 8.25 8.25M2 13c0 6.075 4.925 11 11 11s11-4.925 11-11S19.075 2 13 2 2 6.925 2 13"
    /></g
  ></svg
>

<style>
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
  }
</style>
